<div class="modal-wrapper">

  <div id="limit-container">
    <button *ngIf="hideCancelButton" (click)="cancel()" type="button" mat-icon-button class="close-x" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
    <ion-grid>
      <ion-row>
        <ion-col size="12">
          <h5 class="modal-title">{{ modalTitle }}</h5>
          <mat-divider></mat-divider>
        </ion-col>
        <ion-col size="12">
          <p *ngIf="!message">&iquest;Est&aacute;s seguro de que quieres eliminar el {{ title }}?</p>
          <p *ngIf="message">{{ message }}</p>
        </ion-col>
        <ion-col size="12" *ngIf="confirmName">
          <p class="confirm-hint">Puede afectar a usuarios que ya la tengan en uso. Escribe <b>{{ confirmName }}</b> para confirmar:</p>
          <mat-form-field appearance="fill" class="confirm-field">
            <input matInput [(ngModel)]="confirmInput" [placeholder]="confirmName" autocomplete="off" />
          </mat-form-field>
        </ion-col>
      </ion-row>

      <ion-row id="limit-container-footer">
        <ion-col size="12">
          <button *ngIf="!hideCancelButton" (click)="cancel()" type="button" mat-raised-button [color]="cancelColor" class="me-3">Cancelar</button>
          <button *ngIf="thirdLabel" (click)="confirmThird()" type="button" mat-raised-button [color]="thirdColor" class="me-3">{{ thirdLabel }}</button>
          <button (click)="confirm()" type="button" mat-raised-button [color]="confirmColor" [disabled]="!canConfirm">{{ confirmLabel }}</button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</div>
